import React, { useState } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import { color } from "framer-motion";

function NavBar({load,language}) {
  const [expand, updateExpanded] = useState(false);
  const [navColour, updateNavbar] = useState(false);
/*
  function scrollHandler() {
    if (window.scrollY >= 5) {
//updateNavbar(true);
console.log("scrollY >= 5");

    } else {
      console.log("scrollY >= 5");
    //  updateNavbar(false);
    }
  }

  window.addEventListener("scroll", scrollHandler);
*/
  const handleNavClick = () => {
    updateExpanded(false);
  };

  return load && language !== null ? null :(
    <div>
    {language === 'zh' ? (
      <Navbar
        expanded={expand}
        fixed="top"
        expand="md"
        className={`${navColour ? "sticky" : "navbar"} ${expand ? "navbar" : "navbar-trans"}`}
      >
        <Container>
          <Navbar.Brand href="/" className={`"d-flex" ${expand ? "navbar-header" : "navbar-header-grey"}`} onClick={handleNavClick}>
            {/* <img src={logo} className="img-fluid logo" alt="brand" /> */}
            CKC ll MEDIA WALL
            <br/>
            <h5>by DRAUGHTZMAN and THINGS THAT MOVE</h5>
          </Navbar.Brand>
          <Navbar.Toggle
            aria-controls="responsive-navbar-nav"
            onClick={() => {
              updateExpanded(expand ? false : "expanded");
            }}
            className={expand ? "navbar-toggler" : "navbar-toggler-grey"}
          >
            <span style={{backgroundColor: expand ? "#f1f1f1" : "#1d1d1b"}}></span>
            <span style={{backgroundColor: expand ? "#f1f1f1" : "#1d1d1b"}}></span>
            <span style={{backgroundColor: expand ? "#f1f1f1" : "#1d1d1b"}}></span>
          </Navbar.Toggle>
          <Navbar.Collapse id="responsive-navbar-nav" onClick={handleNavClick}>
            <Nav className="ms-auto " defaultActiveKey="#home" style={{ fontSize: "5"}}>
              <Nav.Item>
                <Nav.Link style={{ lineHeight:"130%", fontSize: "2rem" , letterSpacing: "3px"}} as={Link} to="/" onClick={handleNavClick}>
                  儀表板
                </Nav.Link>
              </Nav.Item>

              <Nav.Item>
                <Nav.Link style={{ lineHeight:"130%", fontSize: "2rem" , letterSpacing: "3px"}} as={Link} to="/about" onClick={handleNavClick}>
                  關於 THE MEDIA WALL
                </Nav.Link>
              </Nav.Item>

              <Nav.Item>
                <Nav.Link style={{ lineHeight:"130%", fontSize: "2rem" , letterSpacing: "3px"}} as={Link} to="/Schedule" onClick={handleNavClick}>
                  時間表
                </Nav.Link>
              </Nav.Item>

              <Nav.Item>
                <Nav.Link style={{ lineHeight:"130%", fontSize: "2rem", letterSpacing: "3px", visibility:"hidden"}} as={Link} to="/TandC" onClick={handleNavClick}>
                  T&C
                </Nav.Link>
              </Nav.Item>
              <div style={{paddingBottom: 50}}/>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    ) : (
      <Navbar
        expanded={expand}
        fixed="top"
        expand="md"
        className={`${navColour ? "sticky" : "navbar"} ${expand ? "navbar" : "navbar-trans"}`}
      >
        <Container>
          <Navbar.Brand href="/" className={`"d-flex" ${expand ? "navbar-header" : "navbar-header-grey"}`} onClick={handleNavClick}>
            {/* <img src={logo} className="img-fluid logo" alt="brand" /> */}
            CKC ll MEDIA WALL
          </Navbar.Brand>
          <Navbar.Toggle
            aria-controls="responsive-navbar-nav"
            onClick={() => {
              updateExpanded(expand ? false : "expanded");
            }}
            className={expand ? "navbar-toggler" : "navbar-toggler-grey"}
          >
            <span style={{backgroundColor: expand ? "#f1f1f1" : "#1d1d1b"}}></span>
            <span style={{backgroundColor: expand ? "#f1f1f1" : "#1d1d1b"}}></span>
            <span style={{backgroundColor: expand ? "#f1f1f1" : "#1d1d1b"}}></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="responsive-navbar-nav" onClick={handleNavClick}>
          <Nav className="ms-auto" defaultActiveKey="#home">
            <Nav.Item>
              <Nav.Link style={{ lineHeight:"130%", fontSize: "2rem", letterSpacing: "3px" }} as={Link} to="/" onClick={handleNavClick}>
                SHOW DASHBOARD
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link style={{ lineHeight:"130%", fontSize: "2rem", letterSpacing: "3px" }} as={Link} to="/about" onClick={handleNavClick}>
                ABOUT THE MEDIA WALL
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link style={{ lineHeight:"130%", fontSize: "2rem", letterSpacing: "3px" }} as={Link} to="/Schedule" onClick={handleNavClick}>
                SCHEDULE
              </Nav.Link>
            </Nav.Item>

            <Nav.Item >
              <Nav.Link style={{ visibility:"hidden", lineHeight:"130%", fontSize: "2rem", letterSpacing: "3px" }} as={Link} to="/TandC" onClick={handleNavClick}>
                T&C
              </Nav.Link>
            </Nav.Item>
            <div style={{paddingBottom: 50}}/>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
    )}
    </div>
  );
}

export default NavBar;

